import {
  CREATE_GROUP_CATEGORY,
  SUCCESS_GROUP_CATEGORY
} from '../constants/action-types'

const initialState = {
  createGroupCategory: {
    creating: false,
    created: false
  }
}

function GroupLevelAdmin(state = initialState, action) {
  if (action.type === CREATE_GROUP_CATEGORY) {
    return {
      ...state,
      ...{ createGroupCategory: { creating: true, created: false } }
    }
  }

  return state
}

export default GroupLevelAdmin
